import { createRequestInterceptor, createResponseInterceptor } from '../createInterceptor'

export const sendFingerprintInterceptor = createRequestInterceptor(
  ({ sendFingerprint }) =>
    (config) => {
      // get the fingerprint from localStorage
      // the fingerprint is recieved from a
      // detail endpoint call that happened some time ago
      const fingerprint = sendFingerprint && localStorage.getItem(sendFingerprint)
      if (sendFingerprint && fingerprint) {
        // endpoints that support fingerprints
        // check if the fingerprint is valid
        // if not valid, the mutation will be rejected
        config.headers['X-Data-Signature'] = fingerprint
        // delete fingerprint after use
        localStorage.removeItem(sendFingerprint)
      }
      return config
    },
)

export const recieveFingerprintInterceptor = createResponseInterceptor(
  ({ recieveFingerprint }) =>
    (response) => {
      // get the fingerprint from the response
      // the fingerprint is valid until other mutations
      if (recieveFingerprint && response.headers.hasOwnProperty('x-data-signature')) {
        const fingerprint = response.headers['x-data-signature']
        localStorage.setItem(recieveFingerprint, fingerprint)
      }
      return response
    },
)
